import type { RxDocument } from 'rxdb';

import getPrimaryKeyFromDatabaseEntry from './getPrimaryKeyFromDatabaseEntry';

export default function getPrimaryKeyFromRxDocument<DocType>(rxDocument: RxDocument<DocType>): string {
  return getPrimaryKeyFromDatabaseEntry(rxDocument, rxDocument.collection);
}
